enum SortBy {
	Deadline = 'Deadline',
}

export default SortBy;
